import React from "react";
import {Banner, Header as MyHeader} from "../../components";
import {Container, Grid} from "semantic-ui-react";
import {isUndefined} from "lodash";
// noinspection ES6CheckImport

import {Posts} from './Posts/';
import {Read} from './Posts/Read';
import {Left} from './Left/';

import {FormattedMessage} from "react-intl";

const subdomain = window.location.host.split('.')[0];

export const City = ({from, blog, location, history, match, pages}) => {
    const {id, title, action, get_id, get_slug} = match.params;

    let reverse = ''
    if(get_id === '0' && get_slug === '0'){
        reverse = 'reverse';
    }

    let path = `/${from}/${id}/${title}`;
    let city = {
        id,
        title,
    };

    if (blog) {
        path = blog.path;
        city = blog;
    }
    const hash = location.hash.substr(1);
    const values = new URLSearchParams(hash);
    const category = action === 'home' ? get_id : (values.get('category') || undefined);
    const page = values.get('page') || 1;
    const author = values.get('author') || '';

    // const BlogTop = styled.div`
    //   background-size: cover;
    //   background-position: center bottom;
    //   background-image: url(/images/banner-blog.jpg);
    //   height: 80px;
    //   margin-bottom: 8px;
    // `;

    let blog_title = from === 'city' ?
        <FormattedMessage id="A Cidade"/> :
        <FormattedMessage id={["europa", "italia"].includes(subdomain) ? "Famílias" : "Cult In Minas"}/>;

    if (blog) {

        blog_title = <FormattedMessage id="Jornal Espaço Horizonte"/>;
    }

    return (
        <React.Fragment>
            <MyHeader/>
            <Container>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column className={'np'}>
                            <Banner city_id={city.id} blog={1} top={1}/>
                        </Grid.Column>
                    </Grid.Row>
                    {
                        isUndefined(pages) && <Grid.Row>
                            <Grid.Column>
                                <h2 className={'ui header'}>{blog_title} {author.length > 0 && ` - ${author}`}</h2>
                            </Grid.Column>
                        </Grid.Row>

                    }
                    <Grid.Row className={reverse}>
                        <Grid.Column mobile={16} tablet={16} computer={pages ? 16 : 11}>
                            {
                                action === 'home' && <Posts
                                    from={from}
                                    city={city}
                                    page={page}
                                    category={category}
                                    location={location}
                                    history={history}
                                    path={path}
                                />
                            }
                            {
                                action === 'read' && <Read
                                    get_id={get_id}
                                    pages={pages}
                                    path={path}
                                />
                            }
                            <Banner city_id={city.id} blog={1} bottom={1} align={'center'}/>
                        </Grid.Column>
                        {
                            isUndefined(pages) && <Grid.Column mobile={16} tablet={16} computer={5}>
                                <Left
                                    from={from}
                                    city={city}
                                    path={path}
                                    category={category}
                                    author={author}
                                />
                            </Grid.Column>
                        }
                    </Grid.Row>
                </Grid>
            </Container>
        </React.Fragment>
    );
};

